import React from "react";
import { Route, Switch, useRouteMatch } from "react-router";
import { Row } from "antd";

import SurveyFormList from "./SurveyFormList";
import SurveyForm from "./SurveyForm";
import FormBuilder from "../../components/FormBuilder/FormBuilder";
import { fetchSurveyDetailsApi, saveSurveyApi } from "utils/apiService";
import SurveyResponse from "./SurveyResponse";


const Survey = (props) => {
	let { path } = useRouteMatch();

	return (
		<Row
			style={{
				width: "100%",
				padding: "40px 25px 70px",
				margin: "60px auto 20px",
				backgroundColor: "#FAFAFA",
			}}
			gutter={[12, 48]}>
			<Switch>
				<Route exact path={`${path}`} component={SurveyFormList} />
				<Route exact path={`${path}/create-form`} render={(props) => <FormBuilder create handleSaveAPI={saveSurveyApi} {...props} />} />
				<Route
					exact
					path={`${path}/:formID/edit`}
					render={(props) => <FormBuilder handleSaveAPI={saveSurveyApi} fetchSurveyDetails={fetchSurveyDetailsApi} {...props} />}
				/>
				<Route exact path={`${path}/:formID/response/:responseID`} component={SurveyResponse} />
				<Route path={`${path}/:formID`} component={SurveyForm} />
				<Route path="*" component={() => <>404 NOT FOUND</>}></Route>
			</Switch>
		</Row>
	);
};

export default Survey;
